/**
 * description: 描述信息
 * author: bql
 * 2023/6/25 16:24
 */

import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class DataModuleCodeApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'data-module-code'
    }

}
 